<template>
  <div >
    <div class="header">

      <div v-if="pvd === 'kuaishou'" class="button" @click="addDouyin">添加快手号</div>
      <div v-else class="button" @click="addDouyin">添加抖音号</div>
    </div>

    <a-table v-if="tiktok" :data-source="tiktok.list" style="margin-top: 36px;" rowKey="id" :pagination="false">
      <a-table-column key="nickname" title="达人昵称" data-index="nickname" />
      <a-table-column key="fan" title="总粉丝数" data-index="fan" />
      <a-table-column key="time_str" title="授权" data-index="time_str" />

      <a-table-column key="action" title="操作" >
        <template slot-scope="text, record">
        <span>
          <a style="" @click="() => onAuth(record)">重新授权</a>
          <a style="color: #ff4242;margin-left: 8px;" @click="() => onDelete(record)">删除</a>
        </span>
        </template>
      </a-table-column>
    </a-table>

    <zy-auth-dialog ref="authDialog" @onCancel="fetchAccount"/>
  </div>
</template>

<script>
import {fetchAccount, deleteAccount} from "@/api/douyin";
import ZyAuthDialog from "@/components/zy-auth-dialog/index.vue";
export default {
  name: "mine-auth",
  components: {
    ZyAuthDialog
  },
  props: {
    pvd: String,
  },
  data() {
    return {
      tiktok: undefined,
      data: [],
    }
  },
  mounted() {
    this.fetchAccount()
  },
  methods: {
    fetchAccount() {
      fetchAccount(this.pvd).then(res => {
        this.tiktok = res
      })
    },
    onAuth(record) {
      console.log(record)
      if (this.pvd === 'kuaishou') {
        this.$refs.authDialog.show(this.tiktok.tip_str, this.tiktok.tip_list, record.img)
      } else {
        this.$refs.authDialog.show(this.tiktok.tip_str, this.tiktok.tip_list, record.qrcode)
      }
    },
    onDelete(record) {
      console.log(record)
      const that = this
      this.$confirm({
        title: '删除提示',
        content: '确认删除该授权信息？删除后无法恢复。',
        okType: 'danger',
        onOk() {
          deleteAccount({id: record.id}, that.pvd).then(res => {
            console.log(res)
            that.fetchAccount()
          })
        },
        onCancel() {},
      });
    },
    addDouyin() {
      if (this.pvd === 'kuaishou') {
        this.$refs.authDialog.show(this.tiktok.tip_str, this.tiktok.tip_list, this.tiktok.img)
      } else {
        this.$refs.authDialog.show(this.tiktok.tip_str, this.tiktok.tip_list, this.tiktok.create_auth_qrcode)
      }

    }
  }
}
</script>

<style scoped lang="scss">
.card {
  background: #FFFFFF;
  box-shadow: 0px 0px 28px 0px rgba(217, 217, 217, 0.19);
  border-radius: 13px;
  padding: 30px;
}

.header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  line-height: 22px;

  .tag {
    width: 3px;
    height: 15px;
    background: #FA6400;
    margin-right: 4px;
  }

  .button {
    height: 28px;
    background: #7557FF;
    border-radius: 5px;
    font-size: 12px;
    color: #FFFFFF;
    line-height: 28px;
    padding-left: 8px;
    padding-right: 8px;
    cursor: pointer;
  }
}
</style>
